import { useEffect, useState } from "react";
import ModalElement from "../../../Common/ModalElement"
import TableElement from "../../../Common/TableElement"
import { getInventoryLog } from "../../../actions/inventory";
import { formatDate } from "../../../utils";
import { headerColumn } from "../../../constants";

const listItems = [
    { title: "Inventory Type", key: "inventoryType" },
    { title: "GPS IMEI", key: "gpsImei" },
    { title: "Device Modal", key: "deviceModel" },
    { title: "SIM IMEI", key: "iccid" },
    { title: "SIM No.", key: "simNumber" },
  ];

const DeviceLogs = ({showLog, hideModal, data }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = () =>{
        setLoading(true);
        getInventoryLog(data?.inventoryId, data?.inventoryTypeId).then(response => {
            const { data } = response.data;
            setLogs(data?.inventoryTransferLogs ?? []);
        }).catch(() => {}).finally(() => setLoading(false));
    }

    useEffect(() => {
        getData();
    }, [])

    return <ModalElement show={showLog} title={"Device Logs"} onHide={hideModal}>
    <div className="device-logs">
        <div className="log-header row g-1 mb-2">
            {listItems.map((item, index) => {
                return <div key={index} className="col-sm-4 d-flex align-items-center">
                    <span className="me-2" style={{fontSize: "20px"}}>•</span>
                    <div className="content">
                        <span>{item.title}:</span> <small className="ms-2">{data?.[item.key] ?? ""}</small>
                    </div>
                </div>
            })}
        </div>
    </div>
    <div className="device-log-table">
        <TableElement data={logs} columns={headerColumn.inventoryLogs} loading={loading} render={(tdData, index)=><tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.transfer_type_name ?? "-"}</td>
            <td>{tdData?.inventory_state_name ?? "-"}</td>
            <td>{tdData?.recipient_name ?? "-"}</td>
            <td>{formatDate(tdData?.created_at ?? "")}</td>
        </tr>} />
    </div>
</ModalElement>
}

export default DeviceLogs;